import React, { Fragment } from "react";
import Card from "@material-ui/core/Card";
import { useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Icon from "@material-ui/core/Icon";
import FavoriteFilled from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import BathtubOutlined from "@material-ui/icons/BathtubOutlined";
import { useRouter } from "next/router";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
//import { Slide } from "react-slideshow-image";
import NextLink from "../NextLink";
import NoImage from "../NoImage";
import PriceDetails from "../PriceDetail";
import useStyles from "./style";
import { makeFavourite, removeFavourite } from "../../../store/actions/Listing";
import BrandConstants from "../../../brands/constants";
import Image from "./../Image";
import screenSize from "./../../states/screen";
import {
  HOST,
  PROPERTY,
  getPropertyDetailPath,
  getPropertyDetail,
} from "../../config/routes";

export default function PropertyMediaCard({
  type,
  city,
  status,
  name,
  district,
  totalApartments,
  tenure,
  street,
  buildYear,
  amenities,
  media,
  _id,
  favourites,
  slug,
  adminMode = false,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isDesktop = screenSize();
  const router = useRouter();

  const isFavourite = favourites && favourites.includes(_id);
  const toggleFavourite = (e) => {
    e.preventDefault();
    if (isFavourite) {
      dispatch(removeFavourite(_id));
    } else {
      dispatch(makeFavourite(_id));
    }
  };

  const chipProps = {};
  const propertyType = BrandConstants.PROPERTY_TYPES.find(
    (propertyTypes) => propertyTypes.code === type
  ).label.toLowerCase();
  const href = {
    pathname: getPropertyDetailPath,
    query: { city, slug, type: propertyType },
  };
  const asHref = `${HOST}${getPropertyDetail(city, slug, propertyType)}`;
  const propertyStatus = BrandConstants.PROPERTY_STATUS.find(
    (propertyStatus) => propertyStatus.code === status
  );
  const propertyDistrict = BrandConstants.DISTRICT.find(
    (propertyDistrict) => propertyDistrict.code === district
  );

  const propertyCreatePath = {
    pathname: PROPERTY,
    query: { id: _id },
  };

  let chipVariant = "default";

  if (isDesktop) {
    chipVariant = "outlined";
  }

  const HangingLabels = () => (
    <Grid container xs={12} spacing={1}>
      {propertyStatus ? (
        <Grid item>
          <Chip
            size="small"
            variant={chipVariant}
            className={classes.chip}
            label={propertyStatus.label}
            color="secondary"
          />
        </Grid>
      ) : null}

      {propertyDistrict ? (
        <Grid item>
          <Chip
            size="small"
            variant={chipVariant}
            className={classes.chip}
            label={propertyDistrict.label}
            color="secondary"
          />
        </Grid>
      ) : null}
    </Grid>
  );

  const renderItem = (image) => {
    return (
      <div className={classes.slide}>
        <img
          className={classes.imageSlide}
          alt={`${name} #${image.index + 1}`}
          src={image.original}
        />
      </div>
    );
  };

  const CardActionAreaComponent = () => (
    <CardContent>
      <Typography noWrap={true} gutterBottom variant="h6" component="h4">
        {name}
      </Typography>

      <Grid container xs={12} spacing={0}>
        <Typography
          variant="body2"
          color="textSecondary"
          component="div"
          className={classes.cardInfoParent}
        >
          {street ? street.name : null},{" "}
          {propertyDistrict && propertyDistrict.length
            ? propertyDistrict[0].label
            : null}
        </Typography>

        <Grid item xs={12}>
          <Typography
            variant="body2"
            color="textSecondary"
            component="div"
            className={classes.cardInfoParent}
          >
            Total Apartments: {totalApartments}
          </Typography>
        </Grid>
      </Grid>
      <Box m={1}>{HangingLabels()}</Box>
    </CardContent>
  );

  const CardActionButtons = () => (
    <CardActions>
      <Grid container wrap="wrap" spacing={1}>
        <Grid item>
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              router.push(propertyCreatePath);
            }}
            color="primary"
          >
            Edit
          </Button>
        </Grid>
      </Grid>
    </CardActions>
  );

  return (
    <Card className={classes.root}>
      <Grid container xs={12}>
        <Grid xs={12} sm={5}>
          {!adminMode ? (
            <Box
              p={1}
              position="absolute"
              zIndex="speed dial"
              top={0}
              right={0}
            >
              <a
                href="#"
                className={classes.favourite}
                onClick={toggleFavourite}
              >
                {isFavourite ? <FavoriteFilled /> : <FavoriteBorder />}
              </a>
            </Box>
          ) : null}

          {media && media.length > 1 ? (
            <div className={classes.slide}>
              <ImageGallery
                infinite={true}
                renderItem={renderItem}
                showBullets={false}
                stopPropagation={true}
                lazyLoad={true}
                showThumbnails={false}
                showFullscreenButton={false}
                showPlayButton={false}
                showIndex={true}
                items={media.map((image, index) => ({
                  original: image.url,
                  thumbnail: image.url,
                  index,
                }))}
              />
            </div>
          ) : media && media.length === 1 ? (
            <div className={classes.slide}>
              <Image src={media[0].url} style={{ height: "100%" }} />
            </div>
          ) : (
            <NoImage />
          )}
        </Grid>
        <Grid xs={12} sm={7}>
          <NextLink href={href}>
            <CardActionArea component="a" style={{height: '100%'}} href={asHref}>
              <CardActionAreaComponent />
            </CardActionArea>
          </NextLink>
          {adminMode ? <CardActionButtons /> : null}
        </Grid>
      </Grid>
    </Card>
  );
}
